import React, { useEffect, useState } from 'react';
import ProjectCard from '../components/ProjectCard';
import { Project } from '../types/Project';
import { useLanguage } from '../contexts/LanguageContext';
import { formatDateWord } from '../utils/dateUtils';

const Home: React.FC = () => {
  const { language, t } = useLanguage();
  const [featuredProjects, setFeaturedProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    // Fetch projects from the JSON file
    fetch('/projects.json')
      .then(response => response.json())
      .then(data => {
        // Filter for featured projects
        const projects = data.projects.filter((project: Project) => project.featured);
        
        // Process projects to include translated content
        const localizedProjects = projects.map((project: Project) => {
          // Get translation in current language or fall back to English
          const translation = project.translations[language] || project.translations.en;
          
          // Create a modified project object with the translated fields
          return {
            ...project,
            title: translation.title,
            description: translation.description,
            // Generate date-word automatically from the date field
            'date-word': formatDateWord(project.date, language)
          };
        });
        
        setFeaturedProjects(localizedProjects);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching projects:', error);
        setLoading(false);
      });
  }, [language]);

  return (
    <>
      <header>
        <h1>{t('titles', 'aboutMe')}</h1>
      </header>
      <main>
        <div className="post-content">
          <p dangerouslySetInnerHTML={{ __html: t('longTexts', 'aboutMe1') }} />
          <p dangerouslySetInnerHTML={{ __html: t('longTexts', 'aboutMe2') }} />
          <p dangerouslySetInnerHTML={{ __html: t('longTexts', 'aboutMe3') }} />
        </div>
        <h2>{t('titles', 'featuredProjects')}</h2>
        <div id="featured-projects">
          {loading ? (
            <p style={{ color: 'var(--muted-color)', fontSize: '.9rem' }}>Loading {t('common', 'projects').toLowerCase()}...</p>
          ) : (
            featuredProjects.map(project => (
              <ProjectCard key={project.id} project={project} />
            ))
          )}
        </div>
      </main>
    </>
  );
};

export default Home;